import React from 'react'
import Footer from '../../components/Footer/Footer'
import Header from '../../components/Header/Header'
import MainSection from '../../components/MainSection/MainSection'
import AboutUs from '../../components/AboutUs/AboutUs'
import OurGames from '../../components/OurGames/OurGames'
import News from '../../components/News/News'
import Events from '../../components/Events/Events'
import LogoEvents from "../../components/LogoEvents/LogoEvents";

import Statistic from '../../components/Statistic/Statistic'
import { Box, Grid2 } from '@mui/material'
import './Home.css'
import OurTeam from '../../components/OurTeam/OurTeam'

const Home: React.FC = () => {
  return (
    <Box className='home-container'>
      <Header />
      <MainSection />
      <Statistic />
      <AboutUs />
      <Grid2
        container
        justifyContent='center'
        alignItems='center'
        columns={{ xs: 10 }}
        size={{ xs: 10 }}
      >
        <Grid2 size={{ xs: 9, md: 8 }}>
          <OurGames />
        </Grid2>
        <Grid2 size={{ xs: 9, md: 8 }}>
          <OurTeam />
        </Grid2>
      </Grid2>
      <Grid2
        container
        justifyContent='center'
        alignItems='center'
        columns={{ xs: 10 }}
        size={{ xs: 10 }}
      >
        <Grid2 size={{ xs: 9, md: 8 }}>
          <News />
        </Grid2>
          <Grid2 size={{ xs: 9, md: 8 }}>
              <Events />
          </Grid2>
          <Grid2 size={{ xs: 9, md: 8 }}>
              <LogoEvents />
          </Grid2>
      </Grid2>
      <Footer />
    </Box>
  )
}

export default Home
